import type { TRuleWithTheme } from '@/styles/theme';

export const disabledIcon: TRuleWithTheme = ({ theme }) => ({
    opacity: 0.3,
    cursor: 'not-allowed',
});
